import React from 'react'
import Modal from '@cloudscape-design/components-themed/modal'

// https://cloudscape.design/components/modal
export function RadModal ({ ...rest }) {
  return (
    <Modal {...rest} />
  )
}
